import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "value"],
  _excluded2 = ["children"];
import * as React from 'react';
export default function toArray(children, option) {
  if (option === void 0) {
    option = {};
  }
  var ret = [];
  React.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else {
      ret.push(child);
    }
  });
  return ret;
}
function convertNodeToOption(node) {
  var _ref = node,
    key = _ref.key,
    _ref$props = _ref.props,
    children = _ref$props.children,
    value = _ref$props.value,
    restProps = _objectWithoutPropertiesLoose(_ref$props, _excluded);
  return _extends({
    key: key,
    value: value !== undefined ? value : key,
    isSelectOption: true,
    // options: null,
    children: children
  }, restProps);
}
export function convertChildrenToData(nodes, childrenKey, optionOnly) {
  if (optionOnly === void 0) {
    optionOnly = false;
  }
  return toArray(nodes).map(function (node, index) {
    var _extends2;
    if (! /*#__PURE__*/React.isValidElement(node) || !node.type) {
      return null;
    }
    var _ref2 = node,
      isSelectOptGroup = _ref2.type.isSelectOptGroup,
      key = _ref2.key,
      _ref2$props = _ref2.props,
      children = _ref2$props.children,
      restProps = _objectWithoutPropertiesLoose(_ref2$props, _excluded2);
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }
    return _extends({
      key: "__AP_SELECT_GRP__" + (key === null ? index : key) + "__",
      isSelectOptGroup: true,
      label: key
    }, restProps, (_extends2 = {}, _extends2[childrenKey] = convertChildrenToData(children, childrenKey), _extends2));
  });
}
function getText(rootChild) {
  var res = '';
  var rr = function rr(child) {
    if (typeof child === 'string' || typeof child === 'number') {
      res += child;
    } else if (Array.isArray(child)) {
      child.forEach(function (c) {
        return rr(c);
      });
    } else if (child && child.props) {
      var children = child.props.children;
      if (Array.isArray(children)) {
        children.forEach(function (c) {
          return rr(c);
        });
      } else {
        rr(children);
      }
    }
  };
  rr(rootChild);
  return res;
}
export function flattenItemsFun(options, params) {
  var childrenAsData = params.childrenAsData,
    childrenKey = params.childrenKey,
    valueKey = params.valueKey,
    labelKey = params.labelKey;
  var flattenList = [];
  function dig(list, isGroupOption) {
    list.forEach(function (data) {
      var label = data[labelKey];
      if (isGroupOption || !(childrenKey in data)) {
        var _flattenList$push;
        var value = data[valueKey];
        flattenList.push((_flattenList$push = {
          key: data.key,
          isGroup: false,
          data: data
        }, _flattenList$push[labelKey] = label, _flattenList$push[valueKey] = value, _flattenList$push));
      } else {
        var _flattenList$push2;
        var grpLabel = label;
        if (grpLabel === undefined && childrenAsData) {
          grpLabel = data[labelKey];
        }

        // Option Group
        flattenList.push((_flattenList$push2 = {
          key: data.key,
          isGroup: true,
          data: data
        }, _flattenList$push2[labelKey] = grpLabel, _flattenList$push2));
        dig(data[childrenKey], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}
export { getText };